import { render } from "./bottomFooter.vue?vue&type=template&id=7c4414a8"
const script = {}

import exportComponent from "D:\\Projects\\icflip-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__